import { action, observable, computed } from 'mobx';

class BackNavigationStore {
  @observable _backUrl = '';

  @action.bound
  setBackUrl(url) {
    this._backUrl = url;
  }

  @computed
  get backUrl() {
    return this._backUrl;
  }
}

const backNavigationStore = new BackNavigationStore();

export default backNavigationStore;
